export const settingTags = ['settings_AddUpdateCarrierQueue'] as const;
